<template>
    <div class="component-service-plan">

        <div :class="isPreview ? 'btn-open-manual-preview' : 'btn-open-manual'">
            <img src="/images/_SVGs/plano_de_servico.svg" :alt="config.alt" onload="SVGInject(this)" />
            <span>{{ config.value }}</span>
        </div>

    </div>
</template>

<script>
    /**
     * Standard component Plano de serviço
     *
     * @param {Object} config       Prop responsável por iniciar o objeto corretamente
     * @param {type}   config.value Seta o label do componente
     */
    export default {
        props: {
            config: {
                type : Object,
                required: true
            },
            isPreview: {
                type : Boolean,
                required: false
            }
        }
    }
</script>

<style lang="scss">
@import '@sass/_variables.scss';
.component-service-plan
{
    display: flex;

    .btn-open-manual
    {
        margin-left: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: $grey;
        font-family: Lato;

        svg {
            margin-right: 10px;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    .btn-open-manual-preview {
        margin-left: 50px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: $grey;
        font-family: Lato;

        svg {
            margin-right: 10px;
        }
    }
}
</style>
